import buildMetricValuesHook from '../utils/buildMetricValuesHook'

export const burgerworksListLocationGroupGuestKpisConfigs = {
  googleRating: 'number',
  googleRatingCount: 'number',
  yelpRating: 'number',
  yelpRatingCount: 'number',
  deliveryAvgCustomerReviewScoreDoordash: 'number',
  smgTotalSurveyCount: 'number',
  smgTotalOutstandingSurveyCount: 'number',
  smgOverallSatisfactionRating: 'number',
  smgAccuracyOfOrderRating: 'number',
  smgOrderNotOnTimeRating: 'number',
  smgFriendlinessOfEmployeesRating: 'number',
  smgTasteOfFoodRating: 'number',
  smgOverallCleanlinessRating: 'number',
} as const

const useBurgerworksListLocationGroupGuestKpis = buildMetricValuesHook({
  groupFilterType: 'corporate',
  metrics: {
    codes: ['delivery_avg_customer_review_score_doordash'],
    groups: ['Expo Module - Guest', 'Expo Module - Location SMG'],
  },
})

export default useBurgerworksListLocationGroupGuestKpis
